import {
  Component,
  Input,
  OnInit
} from '@angular/core';

@Component({
  selector: 'axis-timer,[axis-timer]',
  templateUrl: './timer.component.html'
})
export class TimerComponent implements OnInit {
  interval;
  days: string;
  hours: string;
  minutes: string;
  seconds: string;
  @Input() daysToCount: string;
  @Input() dateToEnd: Date;
  @Input() type = 'days';
  
  ngOnInit() {
    if (this.type) {
      this.type = this.type.toLowerCase();
    }
  }

  start(): void {
    clearInterval(this.interval); // clear timer if running already
    const endTime = this.dateToEnd ? this.dateToEnd : this.addDays(parseInt(this.daysToCount));
    this.updateCountdown(endTime); // initialize timer immediately
    this.interval = setInterval(() => {
      this.updateCountdown(endTime); // update timer every second
    }, 1000);
  }

  stop() {
    clearInterval(this.interval);
    this.days = null;
    this.hours = null;
    this.minutes = null;
    this.seconds = null;
  }

  updateCountdown(endTime): void {
    let difference = Date.parse(endTime) - Date.parse(new Date().toString()); // total time in milliseconds (day + hour + min + sec)
    if (difference <= 0) {
      clearInterval(this.interval);
      this.days = null;
      this.hours = null;
      this.minutes = null;
      this.seconds = null;
    } else {
      this.days = this.padDays(Math.floor(difference / (1000 * 60 * 60 * 24)));
      this.hours = this.pad(Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
      this.minutes = this.pad(Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)));
      this.seconds = this.pad(Math.floor((difference % (1000 * 60)) / 1000));
    }
  }
  private addDays(days: number): Date {
    let date = new Date();
    if (days) { 
      date.setDate(date.getDate() + days);
    }
    return date;
  }

  goTop() {  // reset the page when changing route
    window.scrollTo(0, 0);
  }

  pad(num: number): string {
    return ('0' + num).slice(-2);
  }

  padDays(num: number): string {
    let days = num.toString();
    if (num < 10) {
      days = this.pad(num);
    }
    return days;
  }
}
